module.exports = __webpack_public_path__ + "static/media/prevent-hpv-cancer-news.f673e19e.jpg";